import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { AssetTypeConditional } from 'src/components/user/AssetTypeConditional';
import { RentalAgreementUploader } from '../atomic-components/RentalAgreementUploader';
import { ExpertProtocolUploader } from '../atomic-components/ExpertProtocolUploader';
import { LandRegisterUploader } from '../atomic-components/LandRegisterUploader';
import { EnergyCertificateUploader } from '../atomic-components/EnergyCertificateUploader';
import { UtilityReportUplaoder } from '../atomic-components/UtilityReportUploader';
import { AdditionalDocumentsUploader } from '../atomic-components/AdditionalDocumentsUploader';
import { PlantListUploader } from '../atomic-components/PlantListUploader';

interface Props {
  disabled: boolean;
}

export const AssetUploadPropertyDocuments: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.main.uploadpropertydocuments.title')}>
      <AssetTypeConditional supported={['realEstate', 'builderOwnerModel', 'plot']}>
        <ExpertProtocolUploader disabled={disabled} />
        <LandRegisterUploader disabled={disabled} />
      </AssetTypeConditional>
      <AssetTypeConditional supported={['realEstate', 'builderOwnerModel']}>
        <EnergyCertificateUploader disabled={disabled} />
        <UtilityReportUplaoder disabled={disabled} />
      </AssetTypeConditional>
      <AssetTypeConditional supported={['realEstate', 'powerplant', 'builderOwnerModel']}>
        <RentalAgreementUploader disabled={disabled} />
      </AssetTypeConditional>
      <AssetTypeConditional supported="powerplantPortfolio">
        <PlantListUploader disabled={disabled}></PlantListUploader>
      </AssetTypeConditional>
      <AdditionalDocumentsUploader disabled={disabled} />
    </LaunchpadCard>
  );
};
